import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-68feac30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-container" }

import { computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopCoefficientsPanel',
  props: {
    isLoading: { type: Boolean },
    hasChanges: { type: Boolean }
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const authStore = useAuthStore();

const items = [{ label: "Расходы" }, { label: "Коэффициенты" }];

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["expenses:edit"]);
});

const saveCoefficients = () => {
  emit("save");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createVNode(BreadCrumbs, {
        items: items,
        class: "s-bread"
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          label: "Сохранить",
          class: "save-button m-l-16 m-r-16",
          disabled: isDenied.value || !_ctx.hasChanges,
          onClick: saveCoefficients,
          loading: _ctx.isLoading
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    _: 1
  }))
}
}

})